import { ProductV2 } from '@common'
import { useTranslations } from 'next-intl'

import { isSquadGoldPack } from '@/features/storefronts/productFilters'
import { useTranslatable } from '@/localization/useTranslatable'

import { chunkNumbers } from './strings'
import { useIsRTL } from './useIsRTL'

export const useProductName = (product: ProductV2 | undefined, fallback = 'title') => {
  const t = useTranslations()
  const isRTL = useIsRTL()
  const translatable = useTranslatable()

  if (!product) {
    return fallback
  }

  const title = translatable(product.title, fallback)

  if (isSquadGoldPack(product)) {
    return t('product_amount_2', {
      title,
      amount: isRTL ? product.contentCounts.GEM : chunkNumbers(product.contentCounts.GEM),
    })
  }

  return title
}
